import React, { useRef } from 'react';
import { Body, Container, EntryAnimation, Heading } from '../../atoms';
export default function SimpleHero(param) {
    var title = param.title, description = param.description, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: SimpleHero.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full max-w-md text-left md:text-center"
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: "h1"
    }, title))), !!description && /*#__PURE__*/ React.createElement("div", {
        className: "text-left w-full max-w-sm mt-6 md:mt-7 md:text-center"
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef,
        delay: 0.15
    }, /*#__PURE__*/ React.createElement(Body, {
        className: "prose"
    }, description)))));
}

//# sourceMappingURL=SimpleHero.js.map